
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program-details",
      function () {
        return require("private-next-pages/program-details.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program-details"])
      });
    }
  